<template>
    <div>
        
        <div :class="($route.path == '/CaseInfo') || ($route.path == '/CaseDetail') ? 'fxn-header-left active' : 'fxn-header-left' " >
            <div class="fxn-pull-left" v-if="seat_service == '0'">
                <el-button type="warning" @click="OpenService">开通坐席服务</el-button>
            </div>
            <div class="fxn-pull-left" v-else>
                <div v-show="mem_type == 2">
                    <!-- 无坐席 -->
                    <div v-if="hasSeat == 0 && seatdu.account_id == 0">
                        联系本公司运营人员分配坐席
                    </div>
                    <!-- 无坐席 -->
                    
                    <!--有坐席 -->
                    <div v-else>
                        <!-- 联通 -->
                        <div v-show="callLT">
                            <div v-if="!seats">
                                <el-form :model="TelForm" :rules="TelRules" ref="TelForm">
                                    <el-form-item class="fxn-header-input" label="" prop="phone">
                                        <input class="el-input__inner" type="text" v-model="TelForm.phone" autocomplete="off" maxlength="12" placeholder="请输入电话号码">
                                    </el-form-item>
                                    <div class="fxn-header-button">
                                        <el-button type="success" style="min-width: 32px;height: 36px;" v-for="(item,index) in seatsObj" :key="index" :icon=" 'iconfont '+'iconphone'+(index+1)" @click="submitTel('TelForm',true,item.id)"></el-button>
                                    </div>
                                </el-form>
                            </div>
                            <div v-else-if="seats">
                                <div v-if="seatzt == 1">
                                    <i class="el-icon-service"></i>繁忙/通话中
                                    <el-button type="primary" style="min-width: 32px;height: 36px;" icon="el-icon-phone" @click="submitExitTel('TelExitForm')">挂机</el-button>
                                </div>
                                <div v-else-if="seatzt == 2"><i class="el-icon-loading"></i>繁忙</div>
                                <div v-else-if="seatzt == 3">
                                    <div class="fxn-header-button">
                                        <el-button type="primary" style="min-width: 32px;height: 36px;" icon="el-icon-phone" @click="submitExitTel('TelExitForm')">挂机</el-button>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <!-- 联通 End -->
                    </div>
                    <!-- 有坐席 End -->

                    <!-- 度言 -->
                    <div v-show="callDY" id="ctiIframe"></div>
                    <!-- 度言 End -->
                </div>
            </div>

            <div class="fxn-Header-Data" v-if="mem_type == '2'">
                <div class="item">总案件：<span>{{TopDatas.case_num}}</span></div>
                <div class="item">总金额：<span>{{TopDatas.case_money | Money}}万</span></div>
                <div class="item">回款金额：<span>{{TopDatas.repay_money | Money}}万</span></div>
                <div class="item">剩余金额：<span>{{TopDatas.surplus_money | Money}}万</span></div>
            </div>
        </div>

        <!-- 服务项 -->
        <ServiceItem></ServiceItem>   
        <!-- 服务项 End --> 
    </div>
</template>

<script>
    let ws = '';
    import ServiceItem from './ServiceItem'
    export default {
        components: {
            ServiceItem,
        },
        data(){
            return{
                callLT: true,
                callDY: false,
                seatdu: '',
                hasSeat: '',
                mem_type: '',
                seat_service: '',
                account_id: '',
                seatdutoken: '',
                seats: false,
                seatzt: '',
                StStatus: {},           //坐席状态
                seatsObj: [],
                TopDatas: [],
                Timer: null,

                //拨打电话
                TelForm: {
                    phone: '',
                    case_id: '',
                },
                TelRules: {
                    phone: [
                        { required: true, message: '请输入呼叫号码', trigger: 'blur' },
                    ]
                },
            }
        },
        methods:{
            //度言呼叫
            DYTel(){
                DYSDK.call(this.TelForm.phone,function(){
                });
            },
            //拨打电话
            submitTel(formName,FromTel,seatid){
                if(!this.TelForm.phone){
                    this.$message({
                        message: '请输入手机号码',
                        type: 'error'
                    })
                    return false;
                }
                this.post('/osapi/Call/callOut',{
                    phone: this.TelForm.phone,
                    case_id: this.TelForm.case_id,
                    seat_id: seatid,
                    contacts_id: '',
                })
                .then( res=>{
                    let { msg, code, data } = res.data
                    if( code !=1 ){
                        this.OpenAside.$emit('toTel','','',false)
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                    }else{
                        this.seats = true
                        this.SeatStatus()
                        this.$refs.TelForm.resetFields();
                    }
                })
            },

            //坐席状态
            SeatStatus(){
                let _this = this
                ws = new WebSocket(this.WebSocketUrl);
                let user = JSON.parse(localStorage.getItem('user'));
                if (user) {
                    _this.member_id = user.memberInfo.id
                }
                ws.onopen = function() {
                    ws.send('{"cmd":"seat_msgs","member_id":"'+ _this.member_id +'"}');
                };
                ws.onmessage = function(e) {
                    let seatData = JSON.parse(e.data);
                    _this.StStatus = JSON.parse(e.data);
                    _this.seatzt = seatData.seat_status
                    if (_this.seatzt == '0') {
                        _this.seats = false
                        ws.close();
                        _this.OpenAside.$emit('toTel','','',false)
                    }
                };
                ws.onclose = function (event) {
                }          
            },

            //挂机
            submitExitTel(){
                this.post('/osapi/Call/hangUp')
                .then( res=>{
                   let { msg, code, data } = res.data
                    if( code !==1 ){
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                    }else{
                        this.seats = false;
                        this.OpenAside.$emit('toTel','','',false);

                        ws.close();
                    } 
                })
            },

            //数据统计
            topData(){
                this.get('/osapi/Cases/casesSelfStatic')
                .then(res=>{
                    let { msg, code, data } = res.data
                    if(code !== 1){
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                    }else{
                        this.TopDatas = res.data.data
                    }
                })
            },

            //打开服务窗口
            OpenService(){
                this.OpenAside.$emit('CloseService',true);
            },
        },
        mounted(){
            this.topData();
            //获取已登录用户信息
            let user = JSON.parse(localStorage.getItem('user'));
			if (user) {
                this.hasSeat = user.memberInfo.hasSeat;
                this.mem_type = user.memberInfo.mem_type;
                this.seat_service = user.memberInfo.seat_service;
                this.account_id = user.memberInfo.seatdu.account_id;
                this.seatdutoken = user.memberInfo.seatdu.token;
                this.seatdu = user.memberInfo.seatdu;
                this.seatsObj = user.memberInfo.seats;
            }

            var se = document.createElement('script')
                se.id = 'dySdkScript'
                se.setAttribute('url', 'https://cti.duyansoft.com/ctibar.html?isMute=true&account_id=' + this.account_id + '&token=' + this.seatdutoken + '&noOpBtn=true')
                se.setAttribute('ctype', 'mini')
                se.src = 'https://cti.duyansoft.com/syui/dysdk/dysdk2.min.js'

                // js 加载后执行
                se.onload = () => {
                    
                    DYSDK.ready(() => {
                        
                    })

                    // 正在拨打中的回调函数，返回电话号码等信息
                    DYSDK.callConnecting((data) => {
                        if(data.uuid == null){
                            this.callDY = true;
                            this.callLT = false;
                            this.$message({
                                message: data.errorCode,
                                type: 'error'
                            });
                            this.OpenAside.$emit('toTel','','',false)
                        }
                    })

                    // 接通电话的回调函数，返回电话号码等信息
                    DYSDK.callConfirm((data) => {
                        console.log(data)
                    })
                    
                    // 拨打电话失败的回调函数，返回电话号码等信息
                    DYSDK.callFail((data) => {
                        console.log(data)
                        this.callDY = true;
                        this.callLT = false;
                        this.OpenAside.$emit('toTel','','',false)
                    })

                    // 电话结束的回调函数，返回电话号码等信息
                    DYSDK.callEnd((data) => {
                        console.log(data)
                        this.callDY = true;
                        this.callLT = false;
                        this.OpenAside.$emit('toTel','','',false)
                    })

                    //登录成功后返回accountId.
                    DYSDK.ctiLogined(function(data){
                    });

                    DYSDK.init()
                }


            if(this.seat_service != 0){
                if (this.hasSeat == 0 && this.seatdu.account_id == 0){

                } else if (this.hasSeat > 0 && this.seatdu.account_id == 0){
                    this.callDY = false;
                    this.callLT = true;
                } else if (this.hasSeat == 0 && this.seatdu.account_id > 0){
                    this.callDY = true;
                    this.callLT = false;
                } else {
                    this.callLT = true;
                }
                document.getElementById('ctiIframe').appendChild(se)
            }

            let that = this;
            this.OpenAside.$on('toTel',function(case_phone,case_id,type,calltype,seatid){
                if (type && !that.seats ) {     //如果为拨号并且不在拨号状态中
                    that.TelForm.phone = case_phone;
                    that.TelForm.case_id = case_id;
                    if(calltype == 2){
                        that.callDY = true;
                        that.callLT = false;
                        that.DYTel();
                    }else{
                        that.callLT = true;
                        that.callDY = false;
                        that.submitTel(case_phone,case_id,seatid);
                    }
                }
            }) 
        },
        beforeDestroy() {
            this.OpenAside.$off('toTel')
        },
        watch: {
            seats(val) {
                if (!val) {
                    clearInterval(this.Timer)
                    this.Timer = null;
                } else {
                    this.OpenAside.$emit('toTel','','',true)
                }
            }
        },
    }
</script>

<style scoped>
    .active{
        left: .75rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/Tel.vue